import globalConfig, { localPort } from '../config/global-variables';

/** 
 * getRequestURL
 * 
 * Retrieve Request URL on different ports.
 * For local environment only
 * 
 * @author Molly Liu
 */
export default function getRequestURL(path) {
  let requestURL = '';
  if (path.includes('/client/ip') || path.startsWith('http')) return path;
  if (globalConfig.env === 'local') {
    if (path.startsWith('/api/user')
      || path.startsWith('/api/usermap')
      || path.startsWith('/api/userrole') 
      || path.startsWith('/api/account')
      || path.startsWith('/api/facerecognition') 
      || path.startsWith('/api/file/user')) {
      requestURL = `${globalConfig.API_URL}${localPort.user}${path}`
    } else if (path.startsWith('/api/survey') || path.startsWith('/api/retail') 
      || path.startsWith('/api/posmAuthorization')
      || path.startsWith('/api/file/retail') || path.startsWith('/api/file/survey')
      || path.startsWith('/api/planogram') || path.startsWith('/api/posmGoodsIssueApplication')
      || path.startsWith('/api/posmGoodsIssueApproval') || path.startsWith('/api/seao')) {
      requestURL = `${globalConfig.API_URL}${localPort.survey}${path}`
    } else if (path.startsWith('/api/reportV2')) {
      requestURL = `${globalConfig.API_URL}${localPort.report}${path}`
    } else {
      requestURL = `${globalConfig.API_URL}${localPort.default}${path}`
    }
  } else {
    requestURL = `${globalConfig.API_URL}${path}`
  }
  return requestURL;
}